var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-background"},[_c('transition',{attrs:{"name":"fade","type":"transition","mode":"in-out"}},_vm._l((_vm.stages),function(stage){return (_vm.isActiveStage(stage))?_c('StageBackground',{key:stage.name,ref:'stages',refInFor:true,attrs:{"settings":stage}}):_vm._e()}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a94592","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/AppBackground.vue
// module id = null
// module chunks = 